import React, { useEffect, useState } from 'react';
import { Form, Button, Container, Row, Alert, ProgressBar } from 'react-bootstrap';
import axios from 'axios'
import api from '../../../seller-apis/api';
import servicesApi from '../../../seller-apis/servicesApi'
import { pendingProducts, rejectedProducts } from '../../../seller-apis/apidataField';
import Myalert from '../../common/Myalert';
import Header from '../../common/Header';
import './add-img.css';
import { GenUtilities } from '../../../utilities/GenUtilities';


// Images related
var imagesName = [];
var s3Urls = [];
var imgUrls = [];


// Videos related

var videosName = [];
var vids3Urls = [];
var vidsimgUrls = [];
var currentLink;


function Image(props) {
  // Size states

  const [currView, setcurrView] = useState();

  const [pName, setpName] = useState();
  const [price, setPrice] = useState();
  const [description, setdescription] = useState();
  const [taxClass, settaxClass] = useState();
  const [weight, setweight] = useState();
  const [quantity, setquantity] = useState();
  const [unit, setUnit] = useState();

  // Images Related 
  const [urlList, seturlList] = useState([]);
  const [urlListshow, seturlListshow] = useState(false);
  const [imgprogress, setimgprogress] = useState()

  // Videos related
  const [vidurlList, setvidurlList] = useState([]);
  const [vidurlListshow, setvidurlListshow] = useState(false);
  const [progress, setProgress] = useState()
  const [videoShow, setvideoShow] = useState("none");


  // Toast States
  const [toastWeight, settoastWeight] = useState("none");
  const [toastDescription, settoastDescription] = useState("none");
  const [toastQuantity, settoastQuantity] = useState("none");
  const [toastTax, settoastTax] = useState("none");
  const [toastName, settoastName] = useState("none");
  const [toastPrice, settoastPrice] = useState("none");
  const [toastUnit, settoastUnit] = useState("none");
  const [toastimageUpload, settoastimageUpload] = useState("none");
  const [toastpriceMsg, settoastpriceMsg] = useState();
  const [toastquantityMsg, settoastquantityMsg] = useState();
  const [toastweightMsg, settoastweightMsg] = useState();

  // Alerts related

  const [alertShow, setalertShow] = useState(false)
  const [alertMessage, setAlertMessage] = useState("");
  const [alertType, setalertType] = useState();






  useEffect(() => {
    let size = window.innerWidth;
    if (size > 768) {
      setcurrView('laptop')
    }
    else {
      setcurrView('mobile')
    }
    if (props.match.params.id) {
      let filter = {
        "pageNo": props.match.params.page
      }
      if (props.match.params.from === "pendingProducts") {
        api.product.newProductsRetrieveall(pendingProducts(filter)).then((res) => {
          
          res.products.map((item) => {
            if (item._id === props.match.params.id) {
         
              item.images.map((img) => {
                let i = img.image.substr("9")
                imagesName.push(i);
              })
              setpName(item.productName)
              setPrice(item.price)
              setdescription(item.description)
              settaxClass(item.taxClass)
              setweight(item.weight)
              setquantity(item.quantity)
              seturlList(imagesName)
              setUnit(item.unit)
              seturlListshow(true)
            }
          })
        }).catch((err) => {
          console.log(err)
        })
      }
      else {
        api.product.productsRetrieveall(rejectedProducts(filter)).then((res) => {
        
          res.products.map((item) => {
            if (item._id === props.match.params.id) {
              console.log(item)
              item.images.map((img) => {
                let i = img.image.substr("9")
                imagesName.push(i);
              })
              item.videos.map((video)=>{
                videosName.push(video);
              })
              setpName(item.productName)
              setPrice(item.vendors[0].purchase_price)
              setdescription(item.description)
              settaxClass(item.taxClass)
              setweight(item.weight)
              setquantity(item.quantity)
              seturlList(imagesName)
              setvidurlList(videosName)
              setUnit(item.unit)
              seturlListshow(true)
              setvidurlListshow(true)
            }
          })
        }).catch((err) => {
          console.log(err)
        })
      }
    }
  }, [])

  // Check negative input

  function checkMinusInput(e) {
    if (e.code === "Minus") {
      e.preventDefault();
    }
  }


  function AddProduct() {

    settoastDescription("none");
    settoastName("none");
    settoastPrice("none");
    settoastQuantity("none");
    settoastTax("none");
    settoastUnit("none");
    settoastWeight("none");
    if (pName === undefined || pName === "") {
      settoastName("block")
    } else if (price === undefined || price === "" || price === "0" || price < 0) {
      settoastpriceMsg("Please enter a valid price")
      settoastPrice("block")
    }
    else if (description === undefined || description === "") {
      settoastDescription("block")
    }
    else if (taxClass === undefined || taxClass === "" || taxClass === "GST") {
      settoastTax("block")
    }
    else if (quantity === undefined || quantity === "" || quantity === "0" || quantity < 0) {
      settoastquantityMsg("Please enter a valid quantity")
      settoastQuantity("block")
    }
    else if (unit === undefined || unit === "") {
      settoastUnit("block")
    }
    else if (weight === undefined || weight === "" || weight < 0 || weight === "0") {
      settoastweightMsg("Please enter a valid weight")
      settoastWeight("block")
    }
    else if (imagesName.length <= 0) {
      settoastimageUpload("block")
    }


    else {

      for (let i = 0; i < imagesName.length; i++) {

        if (i === 0) {
          let data = {
            "baseImage": true,
            "smallImage": false,
            "thumbnail": false,
            "visible": false,
            "image": "products/" + imagesName[i],
            "label": imagesName[i]
          }
          imgUrls.push(data);
        }
        else {
          let data = {
            "baseImage": false,
            "smallImage": false,
            "thumbnail": false,
            "visible": false,
            "image": "products/" + imagesName[i],
            "label": imagesName[i]
          }
          imgUrls.push(data);
        }

      }

      let productData;
      if (props.match.params.id) {

        productData = {
          "_id": props.match.params.id,
          "images": imgUrls,
          "description": description,
          "price": price,
          "taxClass": taxClass,
          "weight": weight,
          "quantity": quantity,
          "productName": pName,
          "unit": unit,
          "videos": videosName
        }
      }
      else {
        productData = {
          "images": imgUrls,
          "description": description,
          "price": price,
          "taxClass": taxClass,
          "weight": weight,
          "quantity": quantity,
          "productName": pName,
          "unit": unit,
          "videos": videosName
        }
      }

      api.product.addNewProduct(productData).then((res) => {

        setAlertMessage("Product added successfully")
        setalertShow(true)
        setalertType("lightgreen")
        window.location.assign('/my-inventory')
      }).catch(err => {
        console.log(err)
        setAlertMessage("Failed to add Product")
        setalertShow(true)
        setalertType("red")
      })

    }

  }

  //  Control view acc to size
  function handleResize() {
    if (window.innerWidth > 700) {
      setcurrView('laptop');
    }
    else {
      setcurrView('mobile');
    }

  }


  window.addEventListener('resize', handleResize);

  // Show Image

  function showImage(event) {
    seturlListshow(false)
    settoastimageUpload("none")

    let comImg;
    let imageFinal;
    let registerImage;
    for (let i = 0; i < event.target.files.length; i++) {
      var str = event.target.files[i].name;
      let extension = event.target.files[i].name.slice(event.target.files[i].name.lastIndexOf("."));
      comImg = str.replace(/[^\w]/g, "");
      imageFinal = GenUtilities.removeSpacesFromName(comImg + extension)
      registerImage = event.target.files[0];
      imagesName.push(imageFinal)
      var data = {
        "imageName": imageFinal,
        "type": "products"
      }
      servicesApi.saveImage(data).then((res) => {
        axios({
          method: 'put',
          url: res.data,
          data: registerImage,
          onUploadProgress: data => {
            //Set the progress value to show the progress bar
            setimgprogress(Math.round((100 * data.loaded) / data.total))
          },
        })
          .then(response => {
            setimgprogress()
            seturlList(imagesName)
            seturlListshow(true)
          })
          .catch(error => {
            console.log(error);
          });
      }).catch((err) => console.log(err))
      s3Urls.push(imageFinal)

    }


  }

  // Show Video

  function showVideo(event) {
    setvidurlListshow(false)

    let comImg;
    let imageFinal;
    let registerImage;
    for (let i = 0; i < event.target.files.length; i++) {
      var str = event.target.files[i].name;
      let extension = event.target.files[i].name.slice(event.target.files[i].name.lastIndexOf("."));
      comImg = str.replace(/[^\w]/g, "");
      imageFinal = GenUtilities.removeSpacesFromName(comImg + extension)
      registerImage = event.target.files[0];
      videosName.push(imageFinal)
      var data = {
        "imageName": imageFinal,
        "type": "products"
      }
      servicesApi.saveImage(data).then((res) => {

        axios({
          method: 'put',
          url: res.data,
          data: registerImage,
          onUploadProgress: data => {
            //Set the progress value to show the progress bar
            setProgress(Math.round((100 * data.loaded) / data.total))
          },
        })
          .then(response => {
            setProgress()

            setvidurlList(videosName)
            setvidurlListshow(true)
          })
          .catch(error => {
            console.log(error);
          });
      }).catch((err) => console.log(err))
      vids3Urls.push(imageFinal)

    }
  }



  // Delete image

  function deleteImg(index) {
    seturlListshow(false)
    seturlList([]);

    imagesName.splice(index, 1);
    let eleLoader = document.getElementById("loader-Img-upload");

    seturlList(imagesName)

    eleLoader.setAttribute('class', 'spinner-border text-info');

    setTimeout(() => {

      eleLoader.removeAttribute('class');

      seturlListshow(true)
    }, 1000);
  }

  // Delete video

  function deletevideo(index) {
    setvidurlListshow(false)
    setvidurlList([]);

    videosName.splice(index, 1);
    let eleLoader = document.getElementById("loader-Vid-upload");

    setvidurlList(videosName)

    eleLoader.setAttribute('class', 'spinner-border text-info');

    setTimeout(() => {

      eleLoader.removeAttribute('class');

      setvidurlListshow(true)
    }, 1000);
  }

  // play video

  function playVideo(vidId) {
    currentLink  = vidId
    setvideoShow("block");
    document.getElementById("cntn").classList.add("div-bk");
  }

  // Hide player
   function hidePlayer(){
     document.getElementById("vidPlayer").pause();
     document.getElementById("cntn").classList.remove("div-bk");
    setvideoShow("none");

   }

  function goBack() {
    if (props.match.params.page !== undefined) {
      window.location.assign('/my-inventory')
    }
    else {
      window.location.assign('/add-Product')
    }
  }

 //************************************* */ for mobile *********************************//

  if(currView === "mobile"){
    return (
    <>
      <div>
           {/* Video player */}
           <div id="contain-vid-P" style={{ "display":videoShow}}>
            <span id="vid-P-cross" onClick={()=>hidePlayer()}><i class="bi bi-x-circle-fill"></i></span>
            <video id="vidPlayer" src={currentLink} controls width="100" height="65" />
          </div>


        <div className="py-3 mb-2 bg-theme text-white"><span><i className="fa fa-arrow-left mx-3" onClick={() => goBack()}></i> </span><span ><img src="/logo-search.png" className="w-10"></img> </span>   <span className="mx-2 text-white">Add Product</span></div>

        {alertShow === true ?
          <Alert variant="success" className="Myalert" style={{ "backgroundColor": alertType }} onClose={() => setalertShow(false)} dismissible>
            <Myalert
              message={alertMessage}
            />
          </Alert> : <></>
        }
        <div className="p-0  pr" id="cntn">
          <div className="container">
            <div className="row w-90">
              <div className="col-3 mt-2  pl-1 ">
                <label for="uploadFile1" id="uploadIcon">
                  <i class="fa fa-camera upload-img" aria-hidden="true"></i>
                  <br></br><span className="gry fs-10">Add images</span>
                </label>
                <input type="file" id="uploadFile1" class="uploadFile w-20" onChange={(event) => showImage(event)} multiple accept="image/*" />

              </div>



              {/* Videos */}

              <div className="col-3 mt-2 ">
                <label for="uploadFile2" id="uploadIcon">
                  <i class="fa fa-play-circle upload-img px-2"></i>
                  <br></br><span className="gry fs-10">Add Videos</span>
                  <input type="file" accept="video/*" id="uploadFile2" class="uploadFile w-20" onChange={(event) => showVideo(event)} multiple />
                </label>

              </div>
            </div>
          </div>
          {imgprogress && <ProgressBar id="progress-B" now={imgprogress} label={`${imgprogress}%`} />}
          {progress && <ProgressBar id="progress-B" now={progress} label={`${progress}%`} />}


          <div role="status" id="loader-Img-upload">
            <ul id="contain-Img-Pro " className="d-flex l-n over-flow mb-0" style={{ width: "100%" }}>
              {urlListshow === true ? urlList.map((item, index) => {
                return (
                  <li className="text-center">

                    <img src={"https://s3.toolsvilla.com/mob/products/" + item} width="65" height="65" className="m-2" key={index} alt="img" />
                    <br></br>
                    <i className="bi bi-trash fs-14 text-red" onClick={() => deleteImg(index)}></i>

                  </li>
                )
              }) : <></>}
            </ul>
            <span className="toastAlert" style={{ "display": toastimageUpload }}><i class="fa fa-exclamation" aria-hidden="true"></i> Please select image</span>
          </div>

          <div role="status" id="loader-Vid-upload">
            <ul id="contain-Img-Pro " className="d-flex l-n over-flow mb-0" style={{ width: "100%" }}>
              {vidurlListshow === true ? vidurlList.map((item, index) => {
                return (
                  <>
                  <li className="text-center">
                   
                    <video src={"https://media.toolsvilla.com/mob/products/" + item} onClick={() => playVideo("https://media.toolsvilla.com/mob/products/" + item)} width="65" height="65" className="m-2 vid-P" key={index} alt="img"/>
                    <br></br>
                    <i className="bi bi-trash fs-14 text-red" onClick={() => deletevideo(index)}></i>

                  </li>
                  <div className="play-tag-vid" onClick={() => playVideo("https://media.toolsvilla.com/mob/products/" + item)}>
                  <i class="fa fa-play" aria-hidden="true"></i>
                  </div>
                  </>
                )
              }) : <></>}
            </ul>
            {/* <span className="toastAlert" style={{ "display": toastimageUpload }}><i class="fa fa-exclamation" aria-hidden="true"></i> Please select image</span> */}
          </div>

          <Container>
              <Row className="">

              <div className="col-12">

                <div class="input-cont">
                  <input type="text" name="Number" autocomplete="off" value={pName} onChange={(e) => setpName(e.target.value)} required />
                  <label for="name" class="label-name ">
                    <span class="content-name in-col">
                      Product Name *
                    </span>
                  </label>

                </div>
                <span className="toastAlert" style={{ "display": toastName }}><i class="fa fa-exclamation" aria-hidden="true"></i> Please enter Product Name</span>
              </div>
              <div className="col-6">
                <div class="input-cont">
                  <input type="number" name="text" autocomplete="off" onKeyDown={checkMinusInput} value={price} onChange={(e) => setPrice(e.target.value)} onWheel={(e) => e.target.blur()} required />
                  <label for="name" class="label-name ">
                    <span class="content-name in-col">
                      Price( Inc. GST) *</span>
                  </label>

                </div>
                <span className="toastAlert" style={{ "display": toastPrice }}><i class="fa fa-exclamation" aria-hidden="true"></i> {toastpriceMsg}</span>
              </div>
              <div className="col-6">
                <div class="input-cont">
                  <input type="number" name="text" autocomplete="off" onKeyDown={checkMinusInput} value={quantity} onChange={(e) => setquantity(e.target.value)} onWheel={(e) => e.target.blur()} required />
                  <label for="name" class="label-name ">
                    <span class="content-name in-col">
                      Quantity *</span>
                  </label>

                </div>
                <span className="toastAlert" style={{ "display": toastQuantity }}><i class="fa fa-exclamation" aria-hidden="true"></i> {toastquantityMsg}</span>
              </div>

              <div className="col-6">
                <Form.Select aria-label="Default select example" value={unit} onChange={(e) => setUnit(e.target.value)} className="slct">
                  <option className="area">Unit *</option>
                  <option value="Piece">Piece</option>
                  <option value="Litres">Litres</option>
                  <option value="Kgs">Kgs</option>
                  <option value="Meters">Meters</option>
                  <option value="feet">feet</option>

                </Form.Select>
                <span className="toastAlert" style={{ "display": toastUnit }}><i class="fa fa-exclamation" aria-hidden="true"></i>Please select Unit</span>
              </div>

              <div className="col-6">
                <Form.Select aria-label="Default select example" value={taxClass} onChange={(e) => settaxClass(e.target.value)} className="slct">
                  <option className="area" value="GST">GST% *</option>
                  <option value="5%">5%</option>
                  <option value="12%">12%</option>
                  <option value="18%">18%</option>
                  <option value="0%">0%</option>
                </Form.Select>
                <span className="toastAlert" style={{ "display": toastTax }}><i class="fa fa-exclamation" aria-hidden="true"></i>Please select Tax Class</span>
              </div>

              <div className="col-12">
                <div class="input-cont">
                  <input type="text" name="text" autocomplete="off" value={description} onChange={(e) => setdescription(e.target.value)} required />
                  <label for="name" class="label-name ">
                    <span class="content-name in-col">
                      Description *</span>
                  </label>

                </div>
                <span className="toastAlert" style={{ "display": toastDescription }}><i class="fa fa-exclamation" aria-hidden="true"></i>Please enter Product Description</span>
              </div>
              <div className="col-12">
                <div class="input-cont">
                  <input type="number" name="text" autocomplete="off" onKeyDown={checkMinusInput} value={weight} onChange={(e) => setweight(e.target.value)} onWheel={(e) => e.target.blur()} required />
                  <label for="name" class="label-name ">
                    <span class="content-name in-col">
                      Weight (in Kgs) *</span>
                  </label>

                </div>
                <span className="toastAlert" style={{ "display": toastWeight }}><i class="fa fa-exclamation" aria-hidden="true"></i> {toastweightMsg}</span>
              </div>

            </Row>
          </Container>



          <div className="d-grid gap-2 mt-3">
            <Button variant="secondary" size="lg" onClick={AddProduct} className="bg-theme b-n py-2 mx-2 fs-14" >
              Add Product
            </Button>
          </div>
        </div>

      </div>




    </>



  )
  }
      //************************************* */ for Desktop *********************************//
  else{
   return (
    <>
      <div>
           {/* Video player */}
           <div id="contain-vid-P" style={{ "display":videoShow}}>
            <span id="vid-P-cross" onClick={()=>hidePlayer()}><i class="bi bi-x-circle-fill"></i></span>
            <video id="vidPlayer" src={currentLink} controls width="100" height="65" />
          </div>


        {/* <div className="py-3 mb-2 bg-theme text-white"><span><i className="fa fa-arrow-left mx-3" onClick={() => goBack()}></i> </span><span ><img src="/logo-search.png" className="w-10"></img> </span>   <span className="mx-2 text-white">Add Product</span></div> */}
<Header />
        {alertShow === true ?
          <Alert variant="success" className="Myalert" style={{ "backgroundColor": alertType }} onClose={() => setalertShow(false)} dismissible>
            <Myalert
              message={alertMessage}
            />
          </Alert> : <></>
        }
        <div className="p-0  pr" id="cntn">
        


          <Container className="containe-box">
            <Row>
              <div className="col-9 ">
              <Row className="">

<div className="col-12 col-gap">

  <div class="input-cont">
    <input type="text" name="Number" autocomplete="off" value={pName} onChange={(e) => setpName(e.target.value)} required />
    <label for="name" class="label-name ">
      <span class="content-name in-col">
        Product Name *
      </span>
    </label>

  </div>
  <span className="toastAlert" style={{ "display": toastName }}><i class="fa fa-exclamation" aria-hidden="true"></i> Please enter Product Name</span>
</div>
<div className="col-6 col-gap">
  <div class="input-cont">
    <input type="number" name="text" autocomplete="off" onKeyDown={checkMinusInput} value={price} onChange={(e) => setPrice(e.target.value)} onWheel={(e) => e.target.blur()} required />
    <label for="name" class="label-name ">
      <span class="content-name in-col">
        Price( Inc. GST) *</span>
    </label>

  </div>
  <span className="toastAlert" style={{ "display": toastPrice }}><i class="fa fa-exclamation" aria-hidden="true"></i> {toastpriceMsg}</span>
</div>
<div className="col-6 col-gap">
  <div class="input-cont">
    <input type="number" name="text" autocomplete="off" onKeyDown={checkMinusInput} value={quantity} onChange={(e) => setquantity(e.target.value)} onWheel={(e) => e.target.blur()} required />
    <label for="name" class="label-name ">
      <span class="content-name in-col">
        Quantity *</span>
    </label>

  </div>
  <span className="toastAlert" style={{ "display": toastQuantity }}><i class="fa fa-exclamation" aria-hidden="true"></i> {toastquantityMsg}</span>
</div>

<div className="col-6 col-gap">
  <Form.Select aria-label="Default select example" value={unit} onChange={(e) => setUnit(e.target.value)} className="slct">
    <option className="area">Unit *</option>
    <option value="Piece">Piece</option>
    <option value="Litres">Litres</option>
    <option value="Kgs">Kgs</option>
    <option value="Meters">Meters</option>
    <option value="feet">feet</option>

  </Form.Select>
  <span className="toastAlert" style={{ "display": toastUnit }}><i class="fa fa-exclamation" aria-hidden="true"></i>Please select Unit</span>
</div>

<div className="col-6 col-gap">
  <Form.Select aria-label="Default select example" value={taxClass} onChange={(e) => settaxClass(e.target.value)} className="slct">
    <option className="area" value="GST">GST% *</option>
    <option value="5%">5%</option>
    <option value="12%">12%</option>
    <option value="18%">18%</option>
    <option value="0%">0%</option>
  </Form.Select>
  <span className="toastAlert" style={{ "display": toastTax }}><i class="fa fa-exclamation" aria-hidden="true"></i>Please select Tax Class</span>
</div>

<div className="col-12 col-gap">
  <div class="input-cont">
    <input type="text" name="text" autocomplete="off" value={description} onChange={(e) => setdescription(e.target.value)} required />
    <label for="name" class="label-name ">
      <span class="content-name in-col">
        Description *</span>
    </label>

  </div>
  <span className="toastAlert" style={{ "display": toastDescription }}><i class="fa fa-exclamation" aria-hidden="true"></i>Please enter Product Description</span>
</div>
<div className="col-12 col-gap">
  <div class="input-cont">
    <input type="number" name="text" autocomplete="off" onKeyDown={checkMinusInput} value={weight} onChange={(e) => setweight(e.target.value)} onWheel={(e) => e.target.blur()} required />
    <label for="name" class="label-name ">
      <span class="content-name in-col">
        Weight (in Kgs) *</span>
    </label>

  </div>
  <span className="toastAlert" style={{ "display": toastWeight }}><i class="fa fa-exclamation" aria-hidden="true"></i> {toastweightMsg}</span>
</div>

</Row>
              </div>
              <div className="col-3  p-r">

              <div className="container">
              {imgprogress && <ProgressBar id="progress-B " className="bar" now={imgprogress} label={`${imgprogress}%`} />}
          {progress && <ProgressBar id="progress-B"  className="bar" now={progress} label={`${progress}%`} />}


        
            <div className="row">
              <div className="col-6 mt-2  pl-1 ">
                <label for="uploadFile1" id="uploadIcon">
                  {/* <i class="fa fa-camera upload-img" aria-hidden="true"></i> */}
                  <img src="/add-image.png"  className="upload-img w-80"></img>
                  <br></br><span className="gry fs-11 mx-2">Add images</span>
                </label>
                <input type="file" id="uploadFile1" class="uploadFile w-20" onChange={(event) => showImage(event)} multiple accept="image/*" />

              </div>
              {/* Videos */}
              <div className="col-6 mt-2 ">
                <label for="uploadFile2" id="uploadIcon">
                  <i class="fa fa-play-circle upload-v "></i>
                  <br></br><span className="gry fs-11 mx-2">Add Videos</span>
                  <input type="file" accept="video/*" id="uploadFile2" class="uploadFile w-20" onChange={(event) => showVideo(event)} multiple />
                </label>

              </div>
              <div role="status" id="loader-Img-upload">
            <ul id="contain-Img-Pro " className="d-flex l-n over-flow mb-0" style={{ width: "100%" }}>
              {urlListshow === true ? urlList.map((item, index) => {
                return (
                  <li className="text-center">

                    <img src={"https://s3.toolsvilla.com/mob/products/" + item} width="65" height="65" className="m-2" key={index} alt="img" />
                    <br></br>
                    <i className="bi bi-trash fs-14 text-red" onClick={() => deleteImg(index)}></i>

                  </li>
                )
              }) : <></>}
            </ul>
            <span className="toastAlert" style={{ "display": toastimageUpload }}><i class="fa fa-exclamation" aria-hidden="true"></i> Please select image</span>
          </div>

          <div role="status" id="loader-Vid-upload">
            <ul id="contain-Img-Pro " className="d-flex l-n over-flow mb-0" style={{ width: "100%" }}>
              {vidurlListshow === true ? vidurlList.map((item, index) => {
                return (
                  <>
                  <li className="text-center">
                   
                    <video src={"https://media.toolsvilla.com/mob/products/" + item} onClick={() => playVideo("https://media.toolsvilla.com/mob/products/" + item)} width="65" height="65" className="m-2 vid-P" key={index} alt="img"/>
                    <br></br>
                    <i className="bi bi-trash fs-14 text-red" onClick={() => deletevideo(index)}></i>

                  </li>
                  <div className="play-tag-vid" onClick={() => playVideo("https://media.toolsvilla.com/mob/products/" + item)}>
                  <i class="fa fa-play" aria-hidden="true"></i>
                  </div>
                  </>
                )
              }) : <></>}
            </ul>
            {/* <span className="toastAlert" style={{ "display": toastimageUpload }}><i class="fa fa-exclamation" aria-hidden="true"></i> Please select image</span> */}
          </div>
            </div>
          </div>
          <div className="d-grid gap-2 mt-3">
            <Button variant="secondary" size="lg" onClick={AddProduct} className="bg-theme button-bottom mx-2 " >
              Add Product
            </Button>
          </div>
                
                </div>
                
            </Row>
            
          </Container>



        
        </div>

      </div>




    </>



  )
  }
}




export default Image;